<template>
  <el-row>
    <el-col :span="24">
      <basic-container>
        <avue-crud :option="option"
                   :search.sync="search"
                   :table-loading="loading"
                   :data="data"
                   ref="crud"
                   v-model="form"
                   :permission="permissionList"
                   @row-del="rowDel"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   :before-open="beforeOpen"
                   :page.sync="page"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="refreshChange"
                   @on-load="onLoad">
<!--          <template slot="menuLeft">-->
<!--            <el-button type="danger"-->
<!--                       size="small"-->
<!--                       plain-->
<!--                       icon="el-icon-delete"-->
<!--                       v-if="permissionList.delBtn"-->
<!--                       @click="handleDelete()">删 除-->
<!--            </el-button>-->
<!--          </template>-->
        </avue-crud>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
  import {getList, remove, update, save, view} from "@/api/sys/sysDepfloor";
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        form: {},
        search:{},
        selectionList: [],
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        option: {
          height: 'auto',
          calcHeight: 80,
          align: 'center',
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          selection: true,
          viewBtn: true,
          searchIndex:3,
          searchIcon:true,
          // dialogType: 'drawer',
          dialogClickModal: false,
          dialogDrag: true,
          column: [
            {
              label: "科室编码",
              prop: "deptCode",
              search: true,
              rules: [
                {
                  required: true,
                  message: "请输入科室编码",
                  trigger: "blur"
                }
              ]
            },
            {
              label: "科室名称",
              prop: "deptName",
              search: true,
              rules: [
              ]
            },
            {
              label: "楼层代码",
              prop: "floorCode",
              rules: [
                {
                  required: true,
                  message: "请输入楼层代码",
                  trigger: "blur"
                }
              ]
            },
            {
              label: "楼层名称",
              prop: "floorName",
              rules: [
              ]
            }
          ],
        },
        data: []
      };
    },
    computed: {
      permissionList() {
        return {
          addBtn: true,
          viewBtn: true,
          delBtn: true,
          editBtn: true
        };
      }
    },
    methods: {
      rowSave(row, done, loading) {
        this.$request.processResp(() => save(row), () => this.onLoad(this.page),done, loading)
      },
      rowUpdate(row, index, done, loading) {
        this.$request.processResp(() => update(row), () => this.onLoad(this.page),done, loading)
      },
      rowDel(row) {
        this.handleDelete(row.deptCode)
      },
      searchReset() {
        this.query = {};
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      handleDelete(id) {
        var ids = id ? [id] : this.selectionList.map(item => {
          return item.deptCode
        })
        if (ids.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          return this.$request.processResp(() => remove(ids), () => this.onLoad(this.page), ()=>this.$refs.crud.toggleSelection(), ()=>{})
        });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          view(this.form.deptCode).then(res => {
            this.form = res.data.data;
          });
        }
        done();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        this.loading = true;
        getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
          const data = res.data;
          if (data && data.code === '0') {
            this.page.total = data.data.total;
            this.data = data.data.records;
            this.selectionClear();
          } else {
            this.$message.error(data.msg)
          }
          this.loading = false;
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/sys/sysDepfloor.vue